import { LayoutRegisterOptions, ViewType, registerLayout } from '@kunlun/dependencies';

function registerMultiLayout(params: LayoutRegisterOptions[]) {
  params.forEach((i) => {
    registerLayout(
      `
      <view type="TABLE">
          <pack widget="group">
              <view type="SEARCH">
                  <element widget="search" slot="search" slotSupport="field" />
              </view>
          </pack>
          <pack widget="group" slot="tableGroup">
              <element widget="actionBar" slot="actionBar" slotSupport="action">
                  <xslot name="actions" slotSupport="action" />
              </element>
              <element widget="ActionCountTable" slot="table" slotSupport="field">
                  <element widget="expandColumn" slot="expandRow" />
                  <xslot name="fields" slotSupport="field" />
                  <element widget="rowActions" slot="rowActions" slotSupport="action" />
              </element>
          </pack>
      </view>
          `,
      { ...i }
    );
  });
}

registerMultiLayout([
  {
    model: 'deli.aries.seller.SellerDistributorTradeOrder',
    viewName: '品牌工作台销售订单列表_TABLE_0000000000111524',
    viewType: ViewType.Table
  }
]);
